import { checkedPreviewBlob } from "@proof/ui";
export const requestCredentials = (
  headers: Record<string, string>,
): RequestCredentials =>
  Object.keys(headers).some((name) => name.toLowerCase() === "authorization")
    ? "omit"
    : "same-origin";

export function requestHeaders(
  value: Record<string, string>,
): Record<string, string> {
  try {
    const headers = new Headers(value);
    for (const name of [
      "cookie",
      "host",
      "content-length",
      "connection",
      "transfer-encoding",
      "upgrade",
    ])
      if (headers.has(name)) throw new Error();
    return Object.fromEntries(headers.entries());
  } catch {
    throw new Error("Invalid request headers");
  }
}
export async function assetResponse(response: Response): Promise<Blob> {
  let reader: ReadableStreamDefaultReader<Uint8Array> | undefined;
  try {
    const type =
      response.headers
        .get("content-type")
        ?.split(";")[0]
        .trim()
        .toLowerCase() || "";
    if (
      !response.ok ||
      !response.body ||
      Number(response.headers.get("content-length")) > 20000000 ||
      !["image/png", "image/jpeg", "image/webp"].includes(type)
    )
      throw new Error();
    reader = response.body.getReader();
    const chunks: BlobPart[] = [];
    let bytes = 0;
    while (true) {
      const chunk = await reader.read();
      if (chunk.done) break;
      bytes += chunk.value.byteLength;
      if (bytes > 20000000) throw new Error();
      chunks.push(new Uint8Array(chunk.value));
    }
    return checkedPreviewBlob(new Blob(chunks, { type }));
  } catch {
    throw new Error("IMAGE_PREVIEW_UNAVAILABLE");
  } finally {
    if (reader) {
      await reader.cancel().catch(() => undefined);
      reader.releaseLock();
    } else await response.body?.cancel().catch(() => undefined);
  }
}
